// FIXME: this modal requires multiple builders contained in /builders/suggestions that are not being used by other components
angular
  .module('capability-ng-scheduler')
  .controller(
    'scheduleSuggestionsController',
    function scheduleSuggestionsController(
      $scope,
      $state,
      $stateParams,
      saveSuggestionsCommand,
      suggestions,
      suggestionsService,
      ngTermProgramInfoModel
    ) {
      'use strict';

      $scope.showModal = false;
      $scope.isDrawerOpened = false;

      $scope.termName = _.get(ngTermProgramInfoModel.read(), 'term.name', '');

      $scope.models = {
        suggestions: suggestions,
        filteredSections: []
      };

      $scope.openPreferences = function openPreferences() {
        $state.go('my.schedule.registration.preferences');
      };

      $scope.checked_campuses = _.filter($scope.models.suggestions.campus, function (campus) {
        return !_.find($scope.models.suggestions._unchecked_campuses, {
          id: campus.id
        });
      });

      $scope.getNumSearchedCampuses = function getSearchedCampuses() {
        return _.size($scope.checked_campuses);
      };

      $scope.areAllCoursesAvailable = function areAllCoursesAvailable() {
        var courses = $scope.termSchedule.course;
        return suggestionsService.areAllCoursesAvailable(courses);
      };

      $scope.areUnscheduledCoursesAvailable = function areUnscheduledCoursesAvailable() {
        var sections = $scope.models.suggestions._schedules[$scope.scheduleDisplay];

        return suggestionsService.areUnscheduledCoursesAvailable(sections);
      };

      $scope.hasSchedules = function hasSchedules() {
        return !_.isEmpty($scope.models.suggestions._schedules);
      };

      $scope.hasUncheckedCampuses = function hasUncheckedCampuses() {
        return !_.isEmpty($scope.models.suggestions._unchecked_campuses);
      };

      $scope.isPartial = function isPartial() {
        return $scope.models.suggestions.schedule_completeness === 'PARTIAL';
      };

      $scope.saveSchedule = function saveSchedule(sectionIds) {
        saveSuggestionsCommand($stateParams.termId, sectionIds).then(function () {
          $scope.closeModal();
        });
      };

      $scope.viewSchedule = function viewSchedule(event) {
        const selectedIndex = _.get(event, 'target.selectedIndex', 0);
        if (selectedIndex !== $scope.scheduleDisplay) {
          $scope.scheduleDisplay = selectedIndex;
          $scope.models.filteredSections = filterSections($scope.scheduleDisplay);
        }
      };

      $scope.closeModal = function () {
        $scope.showModal = false;
        return $state.go('^', $stateParams, {
          reload: true
        });
      };

      $scope.gotoRegistration = function () {
        $state.go('my.schedule.registration', { reload: true });
      };

      $scope.openCampusListDrawer = function () {
        $scope.isDrawerOpened = true;
      };

      $scope.onDrawerClosed = function () {
        $scope.isDrawerOpened = false;
      };

      var filterSections = function filterSections(index) {
        // Sort on descending order first on 'is_selected' and then on 'status'...
        var sections = $scope.models.suggestions._schedules[index];
        sections = _.sortByOrder(sections, ['_section_status.is_selected', '_section_status.status'], ['desc', 'desc']);
        return sections;
      };

      activate();

      function activate() {
        $scope.scheduleDisplay = 0;
        $scope.hasUnscheduledCourses = $scope.areUnscheduledCoursesAvailable();
        $scope.models.filteredSections = filterSections($scope.scheduleDisplay);
        $scope.showModal = true;
      }
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/modals/suggestions/suggestions.js